import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import holidays from './modules/holidays';
import formstate from './modules/formstate';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: {},
    modules: {
        user,
        holidays,
        formstate
    }
});
